<template>
  <div>
    <ul class="newsUl wow animate__slideInUp">
      <el-row :gutter="22">
        <el-col
          :xs="24"
          :sm="12"
          :md="6"
          :key="idx"
          v-for="(item, idx) in newsList"
        >
          <a  @click="showImg(true, item.PicUrl)">
            <div class="item">
              <div class="item_pic">
                <div class="bimg">
                  <img :src="item.PicUrl" alt="" width="100%" />
                </div>
              </div>
              <div class="item_txt">
                <div class="item_tit ep2">{{ item.Title }}</div>
              </div>
            </div>
          </a>
        </el-col>
      </el-row>
    </ul>
    <!-- <div class="pageBox">
      <Pagenation />
    </div> -->
    <div class="imgMask" v-if="showHonor" @click="showImg(false)">
      <div class="imgBig">
        <div class="imgBbox">
          <el-image class="imgIner" :src="imgUrl" fit="contain"></el-image>
          <i class="el-icon-error"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagenation from "./Pagenation";

export default {
  data() {
    return {
      moment: this.$moment,
      showHonor: false,
    };
  },
  props: ["actionTxt", "newsList", "down", "lang"],
  components: {
    Pagenation,
  },
  methods: {
    showImg(show, url) {
      this.imgUrl = url;
      this.showHonor = show;
    },
  }
};
</script>

<style lang="scss">
.newsUl {
  border-top: 0;
  .item {
    margin-bottom: 25px;
    .item_pic {
      border: 1px solid #eee;
    }
    .item_txt {
      background: #f2f2f2;
      margin-top:-2px;
      padding: 15px;
      transition:all ease .3s;
    }
    .item_tit {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      .item_txt {
        background: #c6322d;
        color: #fff;
      }
    }
  }
}
.pageBox {
  padding: 40px 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d71820 !important;
}
@media (max-width: 768px) {
  .newsUl .item {
    margin-bottom: 5px;
    .item_tit {
      height: auto;
    }
  }
}
</style>
